import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function InfoSections() {
  const { t } = useTranslation();

  const benefits = [
    { icon: 'ri-file-list-3-line', text: t('benefit1') },
    { icon: 'ri-book-open-line', text: t('benefit2') },
    { icon: 'ri-truck-line', text: t('benefit3') },
    { icon: 'ri-search-eye-line', text: t('benefit4') },
    { icon: 'ri-refresh-line', text: t('benefit5') },
    { icon: 'ri-shield-check-line', text: t('benefit6') },
  ];

  return (
    <>
      <section id="what" className="bg-background-100">
        <div className="mx-auto max-w-7xl px-4 md:px-6 py-16 md:py-20">
          <div className="grid grid-cols-1 gap-8 lg:grid-cols-2 lg:items-center">
            <div>
              <h2 className="text-2xl font-bold text-foreground-950 md:text-3xl font-heading">{t('whatTitle')}</h2>
              <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">{t('whatCopy')}</p>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="mt-6 inline-flex items-center gap-2 rounded-md bg-secondary-500 px-5 py-2.5 text-sm font-semibold text-background-50 hover:bg-secondary-600 whitespace-nowrap cursor-pointer"
              >
                {t('exploreSpreadsheet')}
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>
            <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
              {benefits.map((b) => (
                <div key={b.text} className="flex items-center gap-3 rounded-lg border border-background-200 bg-background-50 p-4">
                  <span className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-lg bg-primary-100 text-primary-700">
                    <i className={`${b.icon} text-lg`}></i>
                  </span>
                  <span className="text-sm font-medium text-foreground-800">{b.text}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="bg-background-50">
        <div className="mx-auto max-w-7xl px-4 md:px-6 py-16 md:py-20">
          <div className="mx-auto max-w-3xl text-center">
            <h2 className="text-2xl font-bold text-foreground-950 md:text-3xl font-heading">{t('whyTitle')}</h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">{t('whyCopy')}</p>
            <Link
              to="/usfans-spreadsheet-guide"
              className="mt-6 inline-flex items-center gap-2 rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 hover:bg-primary-600 whitespace-nowrap cursor-pointer"
            >
              {t('readGuide')}
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}